// src/hooks/hotelRatings/useDeleteHotelRating.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteHotelRating } from "../../api/apiHotelRatings";
import parseError from "../../utils/parseError";

const useDeleteHotelRating = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteHotelRatings, isPending: isDelete } = useMutation({
        mutationFn: deleteHotelRating,
        onSuccess: (res) => {
            const message = res?.message || "Hotel rating deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete hotel rating");
        },
    });

    return { deleteHotelRatings, isDelete };
};

export default useDeleteHotelRating;
